import { useQueryClient } from "@tanstack/react-query";
import { USER_CURRENT_KEY } from "../api/public-voissa/users";

const useCurrentUser = () => {
    const queryClient = useQueryClient();
    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    return currentUser;
}

export default useCurrentUser;